import NewMapForm from './NewMapForm'
import { useGetMarketsQuery } from '../markets/marketsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const NewMap = () => {
    useTitle('ORACLY: New Map')

    const { markets } = useGetMarketsQuery("marketsList", {
        selectFromResult: ({ data }) => ({
            markets: data?.ids.map(id => data?.entities[id], name => data?.entities[name])
        }),
    })

    if (!markets?.length) return <PulseLoader color={"#FFF"} />

    const content = <NewMapForm markets={markets} />

    return content
}
export default NewMap